import { ReactNode } from 'react';
import { Toaster } from 'react-hot-toast';
import styled from 'styled-components';

const StyledPage = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	.toastContainer {
		margin-right: 40px;
		z-index: 101;
		> div > div {
			background-color: ${({ theme }) => theme.toast_bg}!important;
			color: ${({ theme }) => theme.toast_fg}!important;
		}
		@media (max-width: 924px) {
			margin-right: 0;
			> div {
				justify-content: flex-start !important;
			}
		}
	}
`;

export function PageProvider({ children }: { children: ReactNode }) {
	return (
		<StyledPage>
			<Toaster containerClassName="toastContainer" position="top-center" reverseOrder={false} />
			{children}
		</StyledPage>
	);
}
